__turbopack_context__.v({
  "infoBubbleContainer": "InfoBubble-module__1bZCQq__infoBubbleContainer",
});
